import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-31780974"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "introduction"
};
const _hoisted_2 = {
  class: "introduction-img"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "swiper-pagination"
}, null, -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "introduction-info"
}, [/*#__PURE__*/_createElementVNode("p", null, " 全民幸福社前身秋文心理，成立于2013年3月，由李文超与徐秋秋共同创立。经过近10多年发展，目前在北京、上海、济南、西安、厦门、郑州、杭州城市建立了七大交付中心，全国共有30多家合作机构。 "), /*#__PURE__*/_createElementVNode("p", null, " 全民幸福社依托其创始人研发的幸福心理学理论体系，创建了幸福心理课系列课程，包括《幸福心理学》、《教练式父母》、《亲密力量》、《教练之道》、《舞动之道》、《青少年训练营》等，其系列课程在传统心理学根基上融合了精神分析、萨提亚家庭治疗、催眠、完形法、人本主义及神经语言程学等后现代心理学工具。让心理辅导不再只是陪聊、共情，而是从更多角度引发人们对自我心智策略的觉察与看见，通过学习和练习实现心智策略的丰富，从而引发行为策略的丰富，成为一个自由、灵活、幸福的人，改写人生脚本，让心理学不仅仅是疗愈，更是一种成长。通过课程的体验式教学，让每个学习幸福心理学的人都能够看到幸福的真相，能够解决与幸福相关的自我问题，挖掘内心所拥有的积极资源与力量，掌握灵活的行动策略，提升经营幸福的能力，创造出属于自己的幸福之路。 "), /*#__PURE__*/_createElementVNode("p", null, " 全民幸福社着力打造线上线下一站式心理学成长平台，促进幸福心理学的普及。在线上，通过全民幸福社APP，为追求个人成长与自我疗愈的心理学爱好者，以及致力于普及心理学的从业者提供更便捷、更通俗易懂的心理学知识；在线下，通过“幸福心理学”实操课程、“导师学院”、“秋文公益”等课程模块，为追求内在成长或职业成长的教师、心理学从业者、更广大的社会群体提供更落地的心理学实操技能，最终为社会培养出专业技能过硬、具备优秀品质的心理咨询师团体，成为爱与幸福的传播者，让每一个走进全民幸福社的人，都能切实感知幸福体验。 "), /*#__PURE__*/_createElementVNode("p", null, " 未来，全民幸福社将继续推进幸福心理学的线上、线下场景融合，不断提升产品实操应用工具，让心理学走进家庭、学校、社会，构建国民心理四道防线，发挥心理学的成长性，而不仅仅是医疗性，让人们能够通过接触心理学、学习心理学、体验心理学、使用心理学得到切实的幸福感。 ")], -1));
import { Swiper, SwiperSlide } from "swiper/vue";
import { Virtual, Pagination, Autoplay } from "swiper/modules";
import "@/assets/swiper-custom.css";
export default /*#__PURE__*/_defineComponent({
  __name: 'company-introduction',
  setup(__props) {
    const modules = [Virtual, Pagination, Autoplay];
    const pagination = {
      el: ".swiper-pagination",
      clickable: true
    };
    const bannerList = ["https://img2.qiuwenxinli.com/official-website/about-us/introduction-1.jpg", "https://img2.qiuwenxinli.com/official-website/about-us/introduction-2.jpg", "https://img2.qiuwenxinli.com/official-website/about-us/introduction-3.jpg"];
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_unref(Swiper), {
        style: {
          '--swiper-theme-color': '#FFC56E'
        },
        modules: modules,
        loop: true,
        autoplay: {
          delay: 5000 //1秒切换一次
        },

        pagination: pagination,
        allowTouchMove: false,
        class: "introduction-img-swiper"
      }, {
        default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(bannerList, (item, index) => {
          return _createVNode(_unref(SwiperSlide), {
            class: "introduction-img-swiper-item",
            key: index
          }, {
            default: _withCtx(() => [_createElementVNode("img", {
              class: "introduction-img-swiper-item-img",
              src: item
            }, null, 8, _hoisted_3)]),
            _: 2
          }, 1024);
        }), 64)), _hoisted_4]),
        _: 1
      })]), _hoisted_5]);
    };
  }
});